import getImageUrl from '../../../modules/getImageUrl';
import type { Site } from '../../../modules/sites/types/Site';

export default (site: Site): string | null => {
  if (site && site.logo) {
    return getImageUrl(`sites/${site.logo}`);
  }
  return null;
};
